// extracted by mini-css-extract-plugin
export default {"SiteOrange":"#EF7C00","SiteLightGrey":"#B1B1B1","Main":"Spinner_Main__x20aG","MainPadding":"Spinner_MainPadding__EAU5b","Orange":"Spinner_Orange__yiQZw","Gray":"Spinner_Gray__RoAwJ"};